/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import { fromUnixTime, format } from 'date-fns'

const SearchResult = ({ item }) => {
    const {
        body,
        intro,
    } = item.highlights;

    const {
        url,
        title,
        type,
        typeLabel,
        contentDate,
    } = item.document;

    return (
        <a className="search-teaser link link--inverse link--no-underline" href={url}>
            {title && (
                <div className="search-teaser__header">
                    { type === 'file' && (
                        <span className="search-teaser__type">[PDF]</span>
                    )}
                    <span className="search-teaser__title">{title}</span>
                    {contentDate && (<span className="search-teaser__date">({format(fromUnixTime(contentDate), 'dd/MM/yyyy')}) </span>)}
                    {typeLabel && (<span className="search-teaser__label label">{typeLabel}</span>)}
                </div>
            )}
            {intro && intro[0] && (
                <div className="search-teaser__text" dangerouslySetInnerHTML={{ __html: intro[0] }} />
            )}
            {!intro && body && body[0] && (
                <div className="search-teaser__text" dangerouslySetInnerHTML={{ __html: body[0] }} />
            )}
        </a>
    );
};

SearchResult.propTypes = {
    item: PropTypes.shape({}).isRequired,
};

export default SearchResult;
